import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
// import Loader from "../../Layouts/Loader/Loader";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import Navbar from "../../Layouts/Navbar/Navbar";
import TimeProgressBar from "../../components/BuilderComponents/TimeProgressBar";
import Button from "../../components/FormComponents/Button";
import Input from "../../components/FormComponents/Input";
import Textarea from "../../components/FormComponents/Textarea";
import LeftSideBar, { FolderCollapse } from "../../components/SideBar/LeftSideBar";
import { useAppBlocksContext } from "../../context/AppBlocksContext";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { toastSuccess } from "../../utils/toastUtils";
import { useFormContext } from "../../context/FormContext";
import { useModalContext } from "../../context/ModalContext";
import { useNavigationContext } from "../../context/NavigationContext";
import { useStatemachineContext } from "../../context/StatemachineContext";
import { useTableContext } from "../../context/TableContext";
import { useTreeContext } from "../../context/TreeDataContext";
import { getDefaultConfig } from "../../utils/Config/getDefaultConfig";
import { TryAgainMessage } from "../Screen/ScreenSection";
import ImportSmTemplate from "./StateBlueprint/ImportSmTemplate";
import ResizableComponent from "../../Layouts/ResizableComponent";
import HeaderModes from "../../Layouts/Navbar/HeaderModes";
import BuilderTabs from "../../Layouts/BuilderTabs";
import Loader from "../../Layouts/Loader/Loader";
import fileFolderConfig from "../../commonFunctions/fileFolderConfig";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import { AI_PROVIDER_LIST } from "../../constant/constant";
import { getTreeDataForStateMachine } from "../../utils/treeData/treeDataUtils";
import { deleteFolderOfFile, editFolderOrFile, insertNewFileOrFolder } from "../../utils/treeData/folderEditorUtils";

const StateMachineSection = () => {
  const { stateMachineExplorerData, setStateMachineExplorerData, setFormsExplorerData } = useTreeContext();
  const { selectedStateMachine, setSelectedStateMachine, fetchAllStateMachine } = useStatemachineContext();
  const { fetchAllApplicationBlock } = useAppBlocksContext();
  const { getUserConfirmationForDelete } = useModalContext();
  const navigate = useNavigate();
  const { smId } = useParams();
  const { saveChangesAndNavigate } = useNavigationContext();
  const { getAllTableData } = useTableContext();
  const { orgId, appId } = useParams();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoader, setIsLoader] = useState(true);
  const [isError, setIsError] = useState(false);

  const getInsertConfig = (type) => {
    if (type === "activities") {
      return {
        endpoint: "activities",
        config: getDefaultConfig("activity")
      };
    } else if (type === "states") {
      return {
        endpoint: "states",
        config: getDefaultConfig("state")
      };
    } else if (type === "statemachine") {
      return {
        endpoint: "",
        config: getDefaultConfig("statemachine")
      };
    }
    throw new Error("Unknown insert type: " + type);
  };

  const handleNewInsert = async (folder, name) => {
    try {
      const { id } = folder;
      const [smId, type] = id.split("/");

      const { endpoint, config } = getInsertConfig(type);
      config.name = name;
      let apiEndpoint = `/state-machine/${smId}/${endpoint}`;

      const { data, message } = await axiosInstance.post(apiEndpoint, config);
      const newFileId = `${id}/${data.id}`;
      const newItem = fileFolderConfig.getFileConfig(newFileId, data.name, folder.id);
      const updatedExplorerData = insertNewFileOrFolder(stateMachineExplorerData, folder, newItem);
      setStateMachineExplorerData(updatedExplorerData);

      setFormsExplorerData(false);

      callbackFunction(newFileId);
      // navigate(`./${data.id}`);
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };
  const handleDelete = async (folder) => {
    try {
      const { id, name, isFolder } = folder;

      const userConfirmed = await getUserConfirmationForDelete(name);
      if (!userConfirmed) return;

      let endpoint = "";

      if (isFolder) {
        endpoint = `/state-machine/${id}`;
      } else {
        const parts = id.split("/");
        if (parts.length === 3) {
          const [smId, type, entityId] = parts;
          if (type === "states") {
            endpoint = `/state-machine/${smId}/states/${entityId}`;
          } else if (type === "activities") {
            endpoint = `/state-machine/${smId}/activities/${entityId}`;
          }
        } else {
          throw new Error("Unexpected folder.id format: " + id);
        }
      }

      const { message } = await axiosInstance.delete(endpoint);

      const updatedExplorerData = deleteFolderOfFile(stateMachineExplorerData, folder);
      setStateMachineExplorerData(updatedExplorerData);

      if (isFolder && id === selectedStateMachine?.id) {
        navigate(`./`);
        setSelectedStateMachine({ id: "" });
      }

      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleEdit = async (folder, newName) => {
    try {
      const { id, isFolder } = folder;
      let endpoint = "";

      if (isFolder) {
        endpoint = `/state-machine/${id}`;
      } else {
        const parts = id.split("/");
        if (parts.length === 3) {
          const [smId, type, entityId] = parts;
          if (type === "states") {
            endpoint = `/state-machine/${smId}/states/${entityId}`;
          } else if (type === "activities") {
            endpoint = `/state-machine/${smId}/activities/${entityId}`;
          }
        } else {
          throw new Error("Unexpected folder.id format: " + id);
        }
      }

      const { message } = await axiosInstance.put(endpoint, { name: newName });

      const updatedExplorerData = editFolderOrFile(stateMachineExplorerData, folder, newName);
      setStateMachineExplorerData(updatedExplorerData);
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const callbackFunction = (id) => {
    const parts = id.split("/");

    const smId = parts[0];
    const type = parts[1];
    const itemId = parts[2];

    let path = `/organization/${orgId}/app/${appId}/statemachine/${smId}`;

    if (type === "states") {
      path += `/state/${itemId}`;
    } else if (type === "activities") {
      path += `/activity/${itemId}`;
    }

    navigate(path);
  };

  const callbackFunctionForFolder = (folderData) => {
    saveChangesAndNavigate(folderData.id);
  };

  const initialFetching = async () => {
    setIsLoader(true);
    setIsError(false);
    try {
      let smData;
      await getAllTableData();
      if (stateMachineExplorerData && stateMachineExplorerData.length > 0) {
        smData = stateMachineExplorerData;
      } else {
        const { data } = await fetchAllStateMachine();
        smData = data;
        await fetchAllApplicationBlock();
      }

      const newSmData = smData.filter((sm) => sm.sm_type === "default" || sm.type === "default");
      if (newSmData.length > 0 && !smId) {
        navigate(`./${newSmData[0].id}`);
      }
    } catch (error) {
      handleApiError(error);
      setIsError(true);
    } finally {
      setIsLoader(false);
    }
  };

  useEffect(() => {
    initialFetching();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <section className="main_section">
        <div className="sub_section">
          {isError ? (
            <TryAgainMessage retryFunction={initialFetching} />
          ) : (
            <>
              <ResizableComponent
                resizeSide="right"
                storageKey="left_sidebar_size"
                defaultSize={244}
                range={[244, 400]}
                collapsible={true}
              >
                <HeaderModes />
                <div className="d_flex">
                  <Navbar />
                  <LeftSideBar
                    explorerData={stateMachineExplorerData}
                    setExplorerData={setStateMachineExplorerData}
                    selectedScreen={selectedStateMachine}
                    callbackFunction={callbackFunction}
                    callbackFunctionForFolder={callbackFunctionForFolder}
                    handleNewInsert={handleNewInsert}
                    handleDelete={handleDelete}
                    handleEdit={handleEdit}
                    type="SM-Workflow"
                    isLoader={isLoader}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      <FolderCollapse
                        explorerData={stateMachineExplorerData}
                        setExplorerData={setStateMachineExplorerData}
                        type="statemachine"
                      />
                      <MaterialIcon name="add" className="sidebar_icons" onClick={() => setIsModalOpen(true)} />
                    </div>
                  </LeftSideBar>
                </div>
              </ResizableComponent>
              {!isLoader && !isError ? <Outlet /> : <Loader />}

              <BuilderModal
                isOpen={isModalOpen}
                showCloseBtn={!isLoader}
                onClose={() => {
                  setIsModalOpen(false);
                }}
                modalName={"Create State Machine"}
                bodyStyle={{ minHeight: "400px" }}
              >
                <CreateSmModal
                  onClose={() => {
                    setIsModalOpen(false);
                  }}
                  getInsertConfig={getInsertConfig}
                />
              </BuilderModal>
            </>
          )}
        </div>
      </section>
    </>
  );
};

const CreateSmModal = ({ onClose, getInsertConfig }) => {
  const { getOneTableData } = useTableContext();
  const { setStateMachineExplorerData } = useTreeContext();
  const { fetchAllForms } = useFormContext();

  const navigate = useNavigate();

  const handleStateMachineResponse = async (data, message) => {
    await getOneTableData(data.id);
    const singleTreeData = getTreeDataForStateMachine("single", data);
    setStateMachineExplorerData((prevData) => [...prevData, singleTreeData]);
    onClose();
    await fetchAllForms();
    navigate(data.id);
    toastSuccess(message);
  };

  const allTabs = [
    {
      label: "Manual",
      content: (
        <CreateManualSM getInsertConfig={getInsertConfig} handleStateMachineResponse={handleStateMachineResponse} />
      )
    },
    {
      label: "AI",
      content: <CreateAISm handleStateMachineResponse={handleStateMachineResponse} />
    },
    {
      label: "Template",
      content: <ImportSmTemplate handleStateMachineResponse={handleStateMachineResponse} />
    }
  ];
  return <BuilderTabs tabs={allTabs} />;
};

const CreateManualSM = ({ getInsertConfig, handleStateMachineResponse }) => {
  // const [stateMachineName, setStateMachineName] = useState("");
  const [smData, setSmData] = useState({
    name: "",
    is_offline: false
  });
  const [isLoader, setIsLoader] = useState(false);

  const isDisabled = smData.name.trim(" ") ? false : true;

  const onClickBtnHandler = async () => {
    await createStateMachine(smData);
  };

  const createStateMachine = async (smData) => {
    try {
      setIsLoader(true);
      const { config } = getInsertConfig("statemachine");
      config.name = smData.name;
      config.is_offline = smData.is_offline;
      const { data, message } = await axiosInstance.post(`/state-machine`, config);
      await handleStateMachineResponse(data, message);
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoader(false);
    }
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSmData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  return (
    <>
      {isLoader ? (
        <Loader />
      ) : (
        <div className="builder_form mt_4">
          <Input
            type="checkbox"
            label="Offline"
            name="is_offline"
            checked={smData.is_offline}
            onChange={handleChange}
            containerClassName="d_flex justify_start"
          />
          <Input
            label="SM-Workflow Name"
            placeholder="Enter SM-Workflow name"
            value={smData.name}
            name="name"
            // onKeyDown={(e) => keyPressHandler("Enter", e.key, () => createStateMachine(smData.name), isDisabled)}
            onChange={handleChange}
          />
          <Button disabled={isDisabled} isLoading={isLoader} onClick={onClickBtnHandler}>
            Create
          </Button>
        </div>
      )}
    </>
  );
};
const CreateAISm = ({ handleStateMachineResponse }) => {
  const [stateMachineName, setStateMachineName] = useState("");
  const [aiDescription, setAiDescription] = useState("");
  const [aiModel, setAiModel] = useState("open-ai");

  const isDisabled = stateMachineName.trim(" ") && aiModel ? false : true;

  const { orgId } = useParams();
  const [isAiLoading, setIsAiLoading] = useState(false);

  const aiStateMachineGeneration = async (title, description) => {
    try {
      setIsAiLoading(true);
      const { data, message } = await axiosInstance.post(
        "/ai/SMGen",
        { title, description, org_id: orgId, ai_model: aiModel },
        { timeout: 120000 }
      );
      await handleStateMachineResponse(data, message);
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsAiLoading(false);
    }
  };

  const onClickBtnHandler = () => {
    let description = "";
    description = aiDescription;
    aiStateMachineGeneration(stateMachineName, description);
  };

  return (
    <>
      {isAiLoading ? (
        <TimeProgressBar totalTime={30000} interval={1000} />
      ) : (
        <div className="builder_form  mt_4">
          <SingleSelectBox
            selectedData={aiModel}
            options={AI_PROVIDER_LIST}
            label="Select AI Model"
            onChange={(obj) => setAiModel(obj.id)}
            containerClassName={"w_25 mb_0"}
            containerStyle={{ minWidth: "150px" }}
          />

          <Input
            label="SM-Workflow Name"
            placeholder="Enter SM-Workflow name"
            value={stateMachineName}
            // onKeyDown={(e) =>
            //   keyPressHandler("Enter", e.key, () => aiStateMachineGeneration(stateMachineName), isDisabled)
            // }
            onChange={(e) => setStateMachineName(e.target.value)}
          />
          <div>
            <p className="sm_prompt_example mb_2">Eg: Support Ticket Management Workflow</p>

            <Textarea
              value={aiDescription}
              onChange={(e) => setAiDescription(e.target.value)}
              placeholder="Enter Description (Optional)"
            />
          </div>

          <Button disabled={isDisabled} onClick={onClickBtnHandler}>
            Generate
          </Button>
        </div>
      )}
    </>
  );
};

export default StateMachineSection;
